<template>
  <v-menu
    :disabled="disabled"
    close-on-click
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        depressed
        class="pa-1"
        style="min-width: 0;"
        v-on="on"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <template v-for="item in list">
        <v-list-item :key="item.name" link @click="onClick(item)">
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BFormButtonsMenuSave',
  props: {
    disabled: Boolean,
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClick(data) {
      this.$emit(data.name, data)
      this.$emit('select', data)
    },
  },
}
</script>
